import mutations from './treatmentType.mutations'
import actions from './treatmentType.actions'
import getters from './treatmentType.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
